import React, { useState } from "react";
import styles from "./GrowthPlan.module.scss";
import Goals from "./Goals/Goals";
import Engagements from "./Engagements/Engagements";
import History from "./History/History";

interface GrowthPlanProps {}

const GrowthPlan: React.FC<GrowthPlanProps> = () => {
  const [showDetailsPage, setShowDetailsPage] = useState(false);
  const [selectedHistoryData, setSelectedHistoryData] = useState<HistoryItem | null>(null);

  const handleGoalHistoryClick = (goalHistory: HistoryItem) => {
    setShowDetailsPage((prev) => !prev);
    setSelectedHistoryData(goalHistory)

  }
  return (
    <div
      className={`GP_wrapper ${styles.GP_wrapper}`}
      data-testid="growthplan_testID"
    >
      <div className={`content_inner ${styles.GP_inner_wrapper}`}>
        <div className={styles.section_wrapper}>
          <Goals
            selectedHistoryData={selectedHistoryData}
            setSelectedHistoryData={setSelectedHistoryData}
            showDetailsPage={showDetailsPage} 
            setShowDetailsPage={setShowDetailsPage} 
          />
        </div>
        {!showDetailsPage && <>
         <div>
          <Engagements />
        </div>
        <div>
          <History handleGoalHistoryClick={(goalHistory) => handleGoalHistoryClick(goalHistory)}/>
        </div>
        </>
       }
      </div>
    </div>
  );
};

export default GrowthPlan;
